<template>
  <div
    style="max-width: 80vw; overflow-x: scroll"
    :class="isMobileVersion ? 'mobile-text' : ''"
  >
    <table>
      <colgroup>
        <col
          v-for="header of partnersHeaders"
          :key="`${header.key}_col`"
          :style="header.key === 'tasks' ? 'width: 15%' : ''"
        />
      </colgroup>
      <thead>
        <tr>
          <th v-for="header of partnersHeaders" :key="header.key">
            {{ header.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(interest, intIdx) of interestedParty" :key="interest.id">
          <td
            v-for="(header, hIdx) of partnersHeaders"
            v-html="
              `${hIdx === 0 ? `${intIdx + 1}. ` : ''}${getAdditionalParam(
                interest,
                header.key,
              )}`
            "
            :key="`${header.key}_${interest.id}`"
            :class="header.key === 'tasks' ? 'tasks-cell' : ''"
          />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PartnersTable',
  props: {
    interestedParty: Array,
    additionalParams: Array,
  },
  methods: {
    getParamValue(interest, key) {
      return key.split('.').reduce((result, subKey) => result[subKey], interest)
    },
    getAdditionalParam(interest, key) {
      let value = this.getParamValue(interest, key)
      if (key === 'selection.link') {
        return value
          ? `<a href=${value} target="blank" style="color: cornflowerblue; text-decoration: underline;">открыть</a>`
          : ''
      }
      if (key === 'tasks') {
        const htmlStr = value
          .map((task, idx) => {
            const cl = task.isCompleted ? 'text-line-through' : ''
            const num = idx + 1
            const text = task.task.replace('\n', '<br>')
            const postfix = task.isCompleted
              ? `(результат: ${task.result || 'Закрыто без результата'})`
              : `(дата выполнения: ${task.completeTill})`
            return `<div>${num}. <b class="${cl}">${task.type}: </b><span class="${cl}">${text}</span><span> ${postfix}</span></div>`
          })
          .join('\n')
        return htmlStr ? `<div>${htmlStr}</div>` : ''
      }
      if (key.startsWith('cf.')) {
        return value ? value.value : ''
      }
      return value
    },
  },
  computed: {
    isMobileVersion() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    },
    partnersHeaders() {
      const params = {
        'contact.name': 'Имя контакта',
        'contact.phone': 'Телефон',
        'selection.link': 'Ссылка на подборку',
        createdAt: 'Дата заявки',
        status: 'Этап сделки',
        tasks: 'Задачи',
      }
      return this.additionalParams
        .filter((p) => {
          return !this.interestedParty.every(
            (i) => !this.getAdditionalParam(i, p.key),
          )
        })
        .map((p) => {
          const { key } = p
          const interestWithParam = this.interestedParty.find((i) =>
            this.getAdditionalParam(i, key),
          )
          const param = this.getParamValue(interestWithParam, key)
          return { key, name: params[key] || param.name }
        })
    },
  },
}
</script>

<style scoped>
th,
td {
  min-width: 150px;
  text-align: center;
}
td.tasks-cell {
  text-align: left;
}
tr > td {
  border-left: 2px solid black;
  border-right: 2px solid black;
  border-bottom: 2px solid black;
}
tr > th {
  border-left: 2px solid black;
  border-right: 2px solid black;
}
.mobile-text {
  font-size: 0.8em;
}
</style>

<style>
.text-line-through {
  text-decoration: line-through;
}
</style>
